// A lightweight in-app signal that message read-state changed for some entities, so the per-stage
// unread badges can react to a read/unread/mute the moment it happens — without prop-threading a
// refresh callback from the grid's action menus all the way up to the stage strip.
//
// This is WFH-side only. The package already emits `notifyConversationsChanged` for the per-row badges;
// this is the parallel signal for the stage-tab badges, which are computed here (from my-states), not in
// the package.

export interface StageMessagesChange {
  /** The RESOLVED conversation entity type (e.g. 'Assignment'). Stage badges only care about Assignment. */
  entityTypeId: string
  /** The conversation entity ids that changed (for Assignment, these are FboAssignmentIds). */
  entityIds: string[]
  /**
   * True only when we KNOW these were just read (mark-read, panel-open), which lets the badge zero them
   * instantly. Absent for mark-unread / mute, which have no safe optimistic value and reconcile from the
   * server instead.
   */
  optimisticRead?: boolean
}

type Listener = (change: StageMessagesChange) => void

const listeners = new Set<Listener>()

export function emitStageMessagesChange(change: StageMessagesChange): void {
  listeners.forEach((listener) => listener(change))
}

export function onStageMessagesChange(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
